import { useEffect, useState } from 'react';

export type OperatingSystem = 'MacOS' | 'Windows' | 'Linux' | 'Other';

const useOs = () => {
    const [os, setOS] = useState<OperatingSystem>('Other');

    useEffect(() => {
        const userAgent = window.navigator.userAgent;

        if (userAgent.indexOf('Mac') !== -1) {
            setOS('MacOS');
        } else if (userAgent.indexOf('Win') !== -1) {
            setOS('Windows');
        } else if (userAgent.indexOf('Linux') !== -1) {
            setOS('Linux');
        } else {
            setOS('Other');
        }
    }, []);

    return os;
};

export default useOs;
